import audioFileImage from '../assets/icons/flaticons/file-audio.svg'
import csvFileImage from '../assets/icons/flaticons/file-csv.svg'
import imageFileImage from '../assets/icons/flaticons/file-image.svg'
import pdfFileImage from '../assets/icons/flaticons/file-pdf.svg'
import videoFileImage from '../assets/icons/flaticons/file-video.svg'
import textFileImage from '../assets/icons/flaticons/file-text.svg'
import otherFileImage from '../assets/icons/flaticons/file.svg'


const videoMimes = [
  //"video/quicktime",
  "video/3gpp",
  "video/x-msvideo",
  "video/x-ms-wmv",
  "video/mp4",
  "video/mp4v",
  "video/mpg4",
  "video/x-flv",
  "video/webm",
  "video/x-matroska",
];

const otherMimes = [
  "application/pdf"
]

const audioMimes = [
  "audio/mpeg",
  "audio/mp3",
  "audio/mpeg3",
  "audio/x-mpeg-3",
  "audio/ogg",
  "audio/wav",
  "audio/x-m4a"
];

const imagesMimes = [
  "image/jpeg",
  "image/png",
];

const csvMimes = [
  "text/csv",
  "application/csv",
  "application/vnd.ms-excel",
];

const textMimes = [
  "text/plain",
];

const icons = {
  "application/pdf": pdfFileImage,

  "image/jpeg": imageFileImage,
  "image/png": imageFileImage,

  "text/csv": csvFileImage,
  "application/csv": csvFileImage,
  "application/vnd.ms-excel": csvFileImage,

  "audio/mpeg": audioFileImage,
  "audio/ogg": audioFileImage,
  "audio/wav": audioFileImage,
  "audio/mp3": audioFileImage,
  "audio/mpeg3": audioFileImage,
  "audio/x-mpeg-3": audioFileImage,

  "video/x-matroska": videoFileImage,
  "video/quicktime": videoFileImage,
  "video/3gpp": videoFileImage,
  "video/x-msvideo": videoFileImage,
  "video/x-ms-wmv": videoFileImage,
  "video/mp4": videoFileImage,
  "video/mp4v": videoFileImage,
  "video/mpg4": videoFileImage,

  "text/plain": textFileImage,
};

const aceptedMimes = [
  ...otherMimes,
  ...imagesMimes,
  ...audioMimes,
  ...videoMimes,
  ...csvMimes,
  ...textMimes
];

export const mediaConfiguration = {
  icons,
  aceptedMimes
}